import { ELinks } from '@sharedInterfaces/globalEnums';
import { EIconCategory } from '@src/helper/iconRegistry';
import type Employee from '@src/Objects/Employee';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import FeatureCardWidget from './FeatureCardWidget';

interface MissionsCardWidgetProps {
    employee: Employee;
    onTabChange: (tabIndex: number) => void;
}

function MissionsCardWidget({ employee, onTabChange }: MissionsCardWidgetProps) {
    const navigate = useNavigate();

    return (
        <FeatureCardWidget
            title="T4lo Missionen"
            description="Entdecke spannende Lernmissionen und Challenges. Entwickle deine Fähigkeiten spielerisch und sammle Erfahrungen in neuen Bereichen."
            imagePath="/img/t4lo_mssions.png"
            iconCategory={EIconCategory.MISSIONS}
            onClick={() => onTabChange(7)}
        />
    );
}

export default MissionsCardWidget;
